{
    "NAME": "DeviceListLanguage",
    "DeviceList_Column_DeviceNumber": "Device",
    "DeviceList_Column_DeviceNumberInternal": "Extension",
    "DeviceList_Column_Description": "Description",
    "DeviceList_Column_Partition": "Partition",
    "DeviceList_Column_DeviceType": "Device Type",
    "DeviceList_Column_IDOnTelSys": "Resource Account",
    "DeviceList_Column_QueueStatus": "Queue Status",
    "DeviceList_Column_Users": "Users",
    "DeviceList_Filter_DeviceType": "Device Type",
    "DeviceList_Filter_Partition": "Partition",
    "DeviceList_Add_Disabled_SelectTelephonyServer": "Select a Telephony Server to add a device",
    "DeviceList_Users_MoreUsers": "[{} more users]",
    "DeviceList_Value_None": "None",
    "DeviceList_Value_All": "All"
}
